export const splitTopics = topics => {
  const safeTopics = topics ?? []

  const namedTopics = safeTopics.filter(topic => !topic.is_other)
  const otherTopic = safeTopics.find(topic => topic.is_other) ?? null

  return { namedTopics, otherTopic }
}
